import React from "react";

/** White card with subtle navy outline used across all V2 panels. */
export function Card({ children, className = "", testid, ...rest }) {
  return (
    <div
      className={`bg-white rounded-2xl border border-[#0F172A]/[0.08] shadow-[0_1px_0_rgba(15,23,42,0.04)] ${className}`}
      data-testid={testid}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({ eyebrow, title, action, testid }) {
  return (
    <div className="flex items-end justify-between gap-3 px-5 pt-5" data-testid={testid}>
      <div>
        {eyebrow && (
          <div className="text-[10px] tracking-[0.25em] uppercase text-[#F97316] font-semibold mb-1">{eyebrow}</div>
        )}
        <div className="font-serif text-[18px] text-[#081B4B]">{title}</div>
      </div>
      {action}
    </div>
  );
}

export function KpiCard({ label, value, suffix, state = "healthy", delta, beta, betaNote, testid }) {
  const ring = {
    healthy: "ring-emerald-100 bg-emerald-50/70",
    watch: "ring-amber-100 bg-amber-50/60",
    action: "ring-red-100 bg-red-50/70",
    inactive: "ring-slate-100 bg-slate-50/70",
  }[state] || "ring-slate-100 bg-slate-50/70";

  const dot = {
    healthy: "bg-emerald-500",
    watch: "bg-amber-500",
    action: "bg-red-500",
    inactive: "bg-slate-400",
  }[state] || "bg-slate-400";

  return (
    <div
      className={`rounded-2xl ring-1 ${ring} p-5 flex flex-col gap-2`}
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <div className="text-[10px] tracking-[0.22em] uppercase text-[#475569] font-semibold">{label}</div>
        <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      </div>
      <div className="font-serif text-[34px] leading-none text-[#081B4B]">
        {value === null || value === undefined ? "—" : value}
        {suffix && <span className="text-[16px] text-[#475569] ml-1">{suffix}</span>}
      </div>
      <div className="flex items-center justify-between text-[11px] text-[#475569]">
        {delta !== undefined && delta !== null ? (
          <span>+{delta} today</span>
        ) : <span>&nbsp;</span>}
        {beta && (
          <span className="text-[9px] tracking-[0.2em] uppercase text-[#F97316]" title={betaNote || ""}>Beta</span>
        )}
      </div>
    </div>
  );
}

export function PillButton({ children, variant = "secondary", testid, ...rest }) {
  const v = {
    primary: "bg-[#F97316] text-white hover:bg-[#ea670d]",
    secondary: "bg-white text-[#081B4B] border border-[#081B4B]/15 hover:border-[#081B4B]/40",
    ghost: "text-[#475569] hover:text-[#081B4B]",
    dark: "bg-[#081B4B] text-white hover:bg-[#0F2358]",
  }[variant];
  return (
    <button
      className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-[12px] font-semibold transition-colors ${v}`}
      data-testid={testid}
      {...rest}
    >
      {children}
    </button>
  );
}
